import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux';
import { withdrawAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function Widthdraw({ networkID, provider }) {

    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        } else {
            console.log('values',
                form["0"]?.value,
                form["1"]?.value,
            )
            dispatch(withdrawAsyncThunk({ address: form["0"]?.value, amount: form["1"]?.value, type: 1, networkID, provider }));
        }
    };

    return (
        <div className='method-component'>
            <h2>Widthdraw User Balance</h2>
            <p>You can widthdraw your balance from here.</p>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div className='contact-form'>
                    <div className='select-field'>
                        <Form.Group >
                            <div>
                                <Form.Control
                                    type="text"
                                    required
                                    pattern="^0x[a-fA-F0-9]{40}$"
                                    placeholder="Enter Wallet Address for widthdraw"
                                    aria-label="Enter Wallet Address for widthdraw"
                                    aria-describedby="basic-addon2"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid wallet.
                                </Form.Control.Feedback>
                                <Form.Control.Feedback type="valid">
                                    Looks good!
                                </Form.Control.Feedback>
                            </div>
                        </Form.Group>
                        <Form.Group >
                            <div>
                                <Form.Control
                                    type="number"
                                    name="amount"
                                    required
                                    // pattern="^(?=.*\d).{8,}$"
                                    placeholder="amount..."
                                    aria-label="amount..."
                                    aria-describedby="basic-addon2"
                                />
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid Amount.
                                </Form.Control.Feedback>
                                <Form.Control.Feedback type="valid">
                                    Looks good!
                                </Form.Control.Feedback>
                            </div>

                        </Form.Group>

                    </div>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title="Submit"
                                type="submit"
                                slice={'bank'}
                                action={"withdrawAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
